import { Vector2, Vector3 } from 'three';

export class HitUtils {
    static LinesIntersect(lp1: Vector2, lp2: Vector2, lp3: Vector2, lp4: Vector2, intersect: Vector2,
        returnpoint: boolean, extendA: boolean, extendB: boolean): boolean {
        let x1: number = lp1.x;
        let x2: number = lp2.x;
        let x3: number = lp3.x;
        let x4: number = lp4.x;
        let y1: number = lp1.y;
        let y2: number = lp2.y;
        let y3: number = lp3.y;
        let y4: number = lp4.y;

        let denominator: number = ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1));
        if (denominator == 0) // lines are parallel
            return false;
        let numerator_ua: number = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3));
        let numerator_ub: number = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3));
        let ua: number = numerator_ua / denominator;
        let ub: number = numerator_ub / denominator;

        if (!extendA && (ua < 0 || ua > 1)) {
            return false;
        }
        if (!extendB && (ub < 0 || ub > 1)) {
            return false;
        }
        if (extendA || extendB) {
            intersect.x = x1 + ua * (x2 - x1);
            intersect.y = y1 + ua * (y2 - y1);
            return true;
        }
        if (ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1) {
            if (returnpoint) {
                intersect.x = x1 + ua * (x2 - x1);
                intersect.y = y1 + ua * (y2 - y1);
            }
            return true;
        }
        return false;
    }

    // static LinesIntersectWithPoint(lp1: Vector2, lp2: Vector2, lp3: Vector2, lp4: Vector2, extendA: boolean,
    //     extendB: boolean): Vector2 | null {
    //     let x: number = 0, y: number = 0;
    //     if (HitUtils.LinesIntersect(lp1, lp2, lp3, lp4, x, y, true, extendA, extendB)) {
    //         return new Vector2(x, y);
    //     }
    //     return null;
    // }

    static LinesIntersectWithPointExtended(lp1: Vector2, lp2: Vector2, lp3: Vector2, lp4: Vector2, intersect: Vector2): boolean {

        if (this.LinesIntersect(lp1, lp2, lp3, lp4, intersect, true, true, true)) {
            return true;
        }
    
        return false;
    }
    
}
